<template>
	<div id="app" class="main">

		<v-map ref="map" @click="unfocus()" @cta="onCta()" :bbox="bbox"/>

		<div class="top-items" ref="top">
			<v-title class="title-control" :class="{searching:  selecting}"/>
			<v-search class="search-control" @select="select($event)" @search="searching=!!$event.length" ref="search"/>
		</div>

		<div class="floating-buttons">
			<!-- <v-share/> -->
			<v-fullscreen/>
			<v-zoom @zoom="zoomCommand($event)"/>
			<!-- jpv: rajout bouton info en bas de la barre de boutons de controle à droite -->
                        <v-infos/>
		</div>

		<v-cta class="cta-control" @click="onCta()"/>

		<v-overlay ref="overlay"/>
	</div>
</template>

<script>
import VMap from './components/Map.vue'
import VTitle from './components/Title.vue'
import VSearch from './components/Search.vue'
import VFullscreen from './components/Fullscreen.vue'

// jpv: ajout infos component
import VInfos from './components/Infos.vue'

//import VShare from './components/Share.vue'
import VZoom from './components/Zoom.vue'
import VCta from './components/Cta.vue'
import debounce from 'lodash/debounce'
import VOverlay from './components/Overlay.vue'

export default {
	name: 'app',
	components: {
		VMap,
		VSearch,
		VTitle,
		VFullscreen,
		VInfos,
//		VShare,
		VZoom,
		VCta,
		VOverlay,
	},
	data() {
		return {
			searching: false,
			selecting: false,
			bbox: [],
		}
	},
	methods: {
		onCta() {
			this.$refs.overlay.showOverlay()
		},
		unfocus() {
			this.$refs.search.blur()
		},
		onResize(e) {
			const height = this.$refs.top.offsetHeight
			this.$refs.map.setBoundingTop(height)
		},
		zoomCommand(action) {
			this.$refs.map.zoomCommand(action)
		},
		select(ville) {
			this.selecting = true
			this.$refs.map.addVille(ville)
		}
	},
	created() {
		this.debounceResize = debounce(this.onResize, 100)
		const params = {}

		if (location.search.length > 1) {
			const query = location.search.substring(1)
			const vars = query.split('&');

			for (let i = 0, l = vars.length; i < l; i++) {
				const pair = vars[i].split('=');
				params[ decodeURIComponent(pair[0]) ] = decodeURIComponent(pair[1])
    		}
		}

		if (params.bbox) {
			let coords = params.bbox.split(',')
			if (coords.length === 4) {
				this.bbox = coords
			}

		}

		this.$nextTick(function() {
			window.addEventListener("resize", this.debounceResize);
			this.onResize()
		})
	},
}
</script>

<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

#app {
  @extend %font-normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  position: relative;
}

h1,
h2,
h3,
h4 {
	@extend %font-bold;
}


.title-control {
	&.searching {
		//display: none;
	}
}


.floating-buttons {
	z-index: 2000;
	position: absolute;
	top: 50%;
	right: 0;
	transform: translateY(-50%);

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.top-items {
	padding: 12px;
	background-color: $jaune;
	z-index: 1000;
	position:absolute;
	top:0;
	left: 0;
	right:0;
}


.cta-control {
	z-index: 2100;
	position: absolute;
	bottom: 2rem;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
}


</style>
